import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { NavigationStore } from '@services/navigation.store';

export const authCanActivate: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const navigationStore = inject(NavigationStore);
  const router = inject(Router);

  if (!authService.isAuthenticated) {
    navigationStore.setBackUrl(state.url);
    return router.parseUrl('/login');
  }

  if (route.routeConfig?.path?.includes('registration') || route.routeConfig?.path?.includes('order-details')) {
    return true;
  }

  if (authService.isUserProfileIncomplete) {
    return router.parseUrl('/registration');
  }

  return true;
};
